import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { handleClickOutside, getPathname } from '../../Helpers';
import i18next from 'i18next';

const BlogCategoryMenuItem = (id, slug, category, label, clickedCategory, onClick, lang) => (

  <NavLink
    onClick={onClick}
    key={id}
    to={
      {
        pathname: `/${lang}${slug}#${label.toString().toLowerCase().replace(/\s+/g, '-')}`,
        category,
      }
    }
    className={`navbar-item ${clickedCategory === category ? 'is-active' : ''}`}
  >
    {label}
  </NavLink>
);

const BlogCategoryMenu = ({ data, title, clickedCategory }) => {
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation('common');
  const { language } = i18next
  const setAsFalse = () => setIsActive(false);

  const menuRef = useRef(null);

  const menuItemsList = () => {
    let menuItems = [];
    let index = 0;
    if (data.categories) {
      menuItems = data.categories.map((item) => {
        index += 1;

        return BlogCategoryMenuItem(
          index, getPathname(data.meta.html_url), item.id, item.name, clickedCategory, setAsFalse, language
        );
      });
    }
    index += 1;
    menuItems.unshift(BlogCategoryMenuItem(index, getPathname(data.meta.html_url), 'all', t('all_articles'), clickedCategory, setAsFalse, language));

    return menuItems;
  };

  const anchor = window.location.href.split('#')[1];

  useEffect(() => {
    handleClickOutside(menuRef, setAsFalse);
  }, [menuRef]);

  useEffect(() => {
    const items = document.getElementById('promotionsNav')?.querySelectorAll('a');
    /* istanbul ignore next */
    const gotoCategory = (hash) => {
      if (!hash) return;
      if (window.location.href.includes(hash)) {
        items.forEach((item) => {
          if (item.href.includes(hash)) {
            item.click();
          }
        });
      }
    };
    gotoCategory(anchor);
  }, [anchor]);

  return (
    <div className="m-promo-nav m-promo-columns-wrapper container">
      <div className="level is-mobile">
        <div className="level-left">
          <nav className="navbar" role="navigation" aria-label="game navigation" ref={menuRef}>
            <div className="navbar-start">
              <button onClick={() => setIsActive(!isActive)} type="button" className={`m-game-nav-button is-flex-touch is-hidden-desktop ${isActive ? ' is-active' : ''}`} aria-label="game-menu-button" aria-expanded="false" data-menu-target="promotionsNav">
                <div className="is-size-6" aria-label="game-menu-label">{title}</div>
                <div className={`navbar-burger burger is-flex-touch is-static ${isActive ? ' is-active' : ''}`}>
                  <span aria-hidden="true" />
                  <span aria-hidden="true" />
                  <span aria-hidden="true" />
                </div>
              </button>
              <div className={`navbar-menu m-game-nav-menu is-size-5-widescreen ${isActive ? ' is-active' : ''}`} id="promotionsNav">
                {menuItemsList()}
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

BlogCategoryMenu.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  clickedCategory: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
};

BlogCategoryMenu.defaultProps = {
  title: '',
  clickedCategory: '',
};

export default BlogCategoryMenu;
